import _assign from "lodash/assign";
import { handleActions } from "redux-actions";
//
import {
  MODELS_GET,
  MODELS_OFFLINE_GET,
  MODELS_FAVORITE_GET,
  MODEL_GET,
} from "./models/actions";

// ----------------------------------------------------------------------------------------------------------------------------
//  Reducer
// ----------------------------------------------------------------------------------------------------------------------------
const serverState = window.initialState;

const initialState = _assign(
  {
    entities: {},
  },
  serverState.rates
);

export default handleActions(
  {
    [MODELS_GET.FULFILLED]: applyGetModelsFullfilled,
    [MODELS_OFFLINE_GET.FULFILLED]: applyGetModelsFullfilled,
    [MODELS_FAVORITE_GET.FULFILLED]: applyGetModelsFullfilled,
    [MODEL_GET.FULFILLED]: applyGetModelsFullfilled,
  },
  initialState
);

// ----------------------------------------------------------------------------------------------------------------------------
//  Action Reducers
// ----------------------------------------------------------------------------------------------------------------------------
function applyGetModelsFullfilled(state, action) {
  const { entities } = action.payload;

  return {
    ...state,
    entities: { ...state.entities, ...entities.rates },
  };
}
